import React, { useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Suspense } from "react";
import PublicRoute from "./components/PublicRoutes";
import LoadScreen from "./components/LoadScreen";
import MainLoadingScreen from "./components/SharedComponents/MainLoadingScreen";
import appImage from "./assets/images/app.png";
import playstore from "./assets/images/google-play.png";
import appstore from "./assets/images/app-store.png";

// Lazy load public route components
const Login = React.lazy(() => import("./components/Login/Login"));
const Desktopapp = React.lazy(() => import("./components/DesktopApp"));
const PlanSelection = React.lazy(() => import("./components/PlanSelection"));
const CheckoutPage = React.lazy(() => import("./components/CheckoutPage"));
const OtherSoftwareOnboarding = React.lazy(() => import("./components/Onboarding/OtherSoftwareOnboarding"));
const EmployeeLogin = React.lazy(() => import("./components/Login/EmployeeLogin"));

const Approuter = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Call once to set the initial state

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (isMobile) {
    return (
      <div className="flex flex-col gap-[20px] items-center justify-center h-[100vh]">
        <img className="object-cover px-[20px] py-[10px]" src={appImage} alt="Mobile Application" />
        <h1 className="max-w-[500px] px-[10px] text-center">
          Mobile screen is not supported! We have dedicated Mobile app on Playstore and Appstore.
        </h1>
        <div className="flex gap-[10px] px-[10px]">
          <img
            src={playstore}
            alt="playstore button"
            onClick={() => (window.location.href = "https://play.google.com/store/apps/details?id=com.theprofitai")}
          />
          <img
            src={appstore}
            alt="appstore button"
            onClick={() => (window.location.href = "https://apps.apple.com/in/app/theprofit-ai/id6737510354")}
          />
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route
          index
          path="/*"
          element={
            <Suspense fallback={<LoadScreen />}>
              <Desktopapp />
            </Suspense>
          }
        />

        <Route element={<PublicRoute />}>
          <Route
            path="/login"
            element={
              <Suspense fallback={<LoadScreen />}>
                <Login />
              </Suspense>
            }
          />
        </Route>

        {/* Employee Login */}
        <Route element={<PublicRoute />}>
          <Route
            path="/employee/login"
            element={
              <Suspense fallback={<LoadScreen />}>
                <EmployeeLogin />
              </Suspense>
            }
          />
        </Route>

        <Route element={<PublicRoute />}>
          <Route
            path="/plan_selection"
            element={
              <Suspense fallback={<LoadScreen />}>
                <PlanSelection />
              </Suspense>
            }
          />
        </Route>

        <Route element={<PublicRoute />}>
          <Route
            path="/checkout_page/:planId"
            element={
              <Suspense fallback={<LoadScreen />}>
                <CheckoutPage />
              </Suspense>
            }
          />
        </Route>

        <Route element={<PublicRoute />}>
          <Route
            path="/onboarding"
            element={
              <Suspense fallback={<LoadScreen />}>
                <OtherSoftwareOnboarding />
              </Suspense>
            }
          />
        </Route>

        {/* <Route element={<PublicRoute />}>
          <Route
            path="/forgetPassword"
            element={
              <Suspense fallback={<LoadScreen />}>
                <ForgetPassword />
              </Suspense>
            }
          />
        </Route> */}
      </Routes>
    </Router>
  );
};

export default Approuter;
